import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { Constants } from 'src/app/modules/shared/models/constants';

@Component({
    selector: 'app-drawing-button',
    templateUrl: './drawing-button.component.html',
    styleUrl: './drawing-button.component.scss',
    standalone: false
})
export class DrawingButtonComponent {
  @Input() drawingMode = false;
  @Output() clicked = new EventEmitter<void>();

  private subscriptions = new Subscription();
  public isMobile = false;

  constructor(
    private ref: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.isMobile = window.innerWidth < Constants.xs;
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  onClick() {
    this.drawingMode = !this.drawingMode;
    this.clicked.emit();
    this.ref.detectChanges();
  }
}
